export { default } from './TeamChatSoftLinkifyHint';
